import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

/**
 * UIコンテナコンポーネント
 * タブ切り替え式のUIを管理します
 */
const UIContainer: React.FC = () => {
  // アクティブなタブの状態
  const [activeTab, setActiveTab] = useState<'character' | 'inventory' | 'upgrades' | 'achievements'>('character');
  
  const player = useSelector((state: RootState) => state.player);
  
  return (
    <div className="ui-container p-4 h-full flex flex-col">
      <div className="player-info mb-4">
        <h2 className="text-xl font-bold">{player.name}</h2>
        <div className="flex items-center mt-1">
          <span className="mr-2">Lv.{player.level}</span>
          <span className="text-sm text-gray-400">{player.job}</span>
        </div>
        <div className="experience-bar mt-2">
          <div className="text-sm">経験値: {player.experience}</div>
          <div className="w-full bg-gray-700 h-2 rounded-full overflow-hidden">
            <div 
              className="bg-green-500 h-full rounded-full" 
              style={{ width: `${Math.min(100, (player.experience / (player.level * 100)) * 100)}%` }}
            ></div>
          </div>
        </div>
      </div>
      
      <div className="tab-container mb-4">
        <div 
          className={`tab ${activeTab === 'character' ? 'tab-active' : ''}`}
          onClick={() => setActiveTab('character')}
        >
          キャラ
        </div>
        <div 
          className={`tab ${activeTab === 'inventory' ? 'tab-active' : ''}`}
          onClick={() => setActiveTab('inventory')}
        >
          アイテム
        </div>
        <div 
          className={`tab ${activeTab === 'upgrades' ? 'tab-active' : ''}`}
          onClick={() => setActiveTab('upgrades')}
        >
          強化
        </div>
        <div 
          className={`tab ${activeTab === 'achievements' ? 'tab-active' : ''}`}
          onClick={() => setActiveTab('achievements')}
        >
          実績
        </div>
      </div>
      
      <div className="tab-content flex-grow overflow-auto">
        {activeTab === 'character' && (
          <div className="character-tab">
            <h3 className="text-lg font-semibold mb-2">ステータス</h3>
            <div className="grid grid-cols-2 gap-2">
              <div className="stat-item">
                <span className="text-gray-400">HP:</span>
                <span className="ml-2">{player.stats.hp}</span>
              </div>
              <div className="stat-item">
                <span className="text-gray-400">攻撃:</span>
                <span className="ml-2">{player.stats.attack}</span>
              </div>
              <div className="stat-item">
                <span className="text-gray-400">防御:</span>
                <span className="ml-2">{player.stats.defense}</span>
              </div>
              <div className="stat-item">
                <span className="text-gray-400">速度:</span>
                <span className="ml-2">{player.stats.speed}</span>
              </div>
              <div className="stat-item">
                <span className="text-gray-400">魔力:</span>
                <span className="ml-2">{player.stats.magicPower}</span>
              </div>
            </div>
            
            <h3 className="text-lg font-semibold mb-2 mt-4">スキル</h3>
            {player.skills.length > 0 ? (
              <div className="skills-list">
                {player.skills.map(skill => (
                  <div key={skill.id} className="skill-item p-2 bg-gray-700 rounded-md mb-2">
                    <div className="flex justify-between">
                      <span>{skill.id}</span>
                      <span>Lv.{skill.level}</span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-gray-400">スキルがありません</p>
            )}
          </div>
        )}
        
        {activeTab === 'inventory' && (
          <div className="inventory-tab">
            <p className="text-gray-400">インベントリは開発中です</p>
          </div>
        )}
        
        {activeTab === 'upgrades' && (
          <div className="upgrades-tab">
            <p className="text-gray-400">アップグレードは開発中です</p>
          </div>
        )}
        
        {activeTab === 'achievements' && (
          <div className="achievements-tab">
            <p className="text-gray-400">実績は開発中です</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UIContainer; 